var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Pergunta",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.pergunta,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "pergunta", $$v);
      },
      expression: "form.filters.pergunta"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarFaqs();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterFaq();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "show-expand": "",
      "expanded": _vm.expanded,
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.pergunta`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('p', {
          staticClass: "text-wrap",
          staticStyle: {
            "max-width": "50vw"
          }
        }, [_vm._v(_vm._s(item.pergunta))])];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref2) {
        var headers = _ref2.headers,
          item = _ref2.item;
        return [_c('td', {
          staticClass: "blue-grey lighten-3",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('p', {
          staticClass: "ml-4 text-wrap",
          staticStyle: {
            "max-width": "70vw"
          }
        }, [_vm._v(_vm._s(item.resposta))])])];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarFaq(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar",
            "icon": "mdi-pencil",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterFaq(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.ativo ? 'var(--primary-button-color)' : 'silver'}`,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.alterarStatusFaq(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('VisualizarFaqDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarFaq.visible,
      "content": _vm.dialogVisualizarFaq.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarFaq.close();
      }
    }
  }), _c('CadastrarEditarFaqDialog', {
    attrs: {
      "edit": _vm.dialogManterFaq.edit,
      "visible": _vm.dialogManterFaq.visible,
      "content": _vm.dialogManterFaq.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterFaq.close();
      },
      "onSave": function ($event) {
        return _vm.buscarFaqs();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }